import { Box, Alert } from '@mui/material';
import { useDrop } from 'react-dnd';
import { useState } from 'react';
import ShortUniqueId from 'short-unique-id';
import {NotificationDialog} from '../../CommonFunctions/DialogComponents';
import { TAlert } from '../../../types/types';

interface IDropZone {
  children: React.ReactNode;
  propKey: string;
}

const GroupDropZone = ({ children, propKey }: IDropZone) => {
  const [alert, setAlert] = useState<null | TAlert>(null);;
  const uid = new ShortUniqueId({ length: 4 });

  const [, drop] = useDrop({
    accept: ['card', 'calculationSelected'],
    drop: (item: any) => {

      if (item.type === 'card') {
        const dataType = item.fieldData?.dataType?.toLowerCase();
        const fieldName = item.fieldData?.fieldname?.toLowerCase();

        if (
          !(
            ['string','text'].includes(dataType)
            //  === 'text' ||
            // fieldName.includes('email') ||
            // item.fieldData?.displayname?.toLowerCase()?.includes('email')
          )
        ) {
          setAlert({
            message: 'Only fields related to group names can be dropped here!',
            severity: 'error',
          });
          return;
        }

        // Simulate success
        // alert(`Accepted Email Field: ${item.fieldData.displayname}`);
        setAlert({
            message: `Accepted group names Field: ${item.fieldData.displayname}`,
            severity: 'success',
          });
      } else if (item.type === 'calculationSelected') {
        const flowDatatype = item.flowDatatype;

        if (
          !flowDatatype ||
          !['string','text'].includes(flowDatatype.toLowerCase())
        ) {
          setAlert({
            message: 'Only flows related to group names can be dropped here!',
            severity: 'error',
          });
          return;
        }

        setAlert({
            message: `Accepted Flow Source: ${item.uid}`,
            severity: 'success',
          });
        // alert(`Accepted Flow Source: ${item.uid}`);
      }
    },
  });

  return (
    <Box ref={drop} sx={{ borderRadius: '8px', padding: 1 }}>
      {alert && (
        <NotificationDialog
          onCloseAlert={() => setAlert(null)}
          severity={alert.severity}
          testMessage={alert?.message}
          openAlert={!!alert}
        />
      )}
      {children}
    </Box>
  );
};

export default GroupDropZone;
